import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import ImageLoader from '@merchantlabs/gatsby-image-loader'
import { transparentize } from 'polished'

import Modal from './modal'

export default class Activity extends Component {
  state = {
    showModal: false
  }

  toggleModal = () => this.setState({ showModal: !this.state.showModal })

  render() {
    const { name, description, images, link } = this.props
    const { showModal } = this.state
    return (
      <Fragment>
        <Modal
          showModal={showModal}
          toggleModal={this.toggleModal}
          name={name}
          description={description}
          images={images}
          link={link}
        />
        <ImageLoader sizes={images[0].image.childImageSharp.fluid}>
          {({ src }) => (
            <Container url={src} onClick={this.toggleModal}>
              <Heading>{name}</Heading>
            </Container>
          )}
        </ImageLoader>
      </Fragment>
    )
  }
}

const Container = styled.div`
  height: 300px;
  flex: 350px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  flex-direction: column;
  margin: 5px;
  box-shadow: 0 15px 80px rgba(0, 0, 0, 0.3);
  background: linear-gradient(
      to bottom,
      ${transparentize(1, '#000')} 60%,
      ${transparentize(0.4, '#000')}
    ),
    url(${props => props.url});
  background-size: cover;
  cursor: pointer;
  transition-duration: 0.5s;

  &:hover {
    background: linear-gradient(
        to right,
        ${transparentize(0.3, '#000')},
        ${transparentize(0.3, '#000')}
      ),
      url(${props => props.url});
    background-size: cover;
  }

  @media (max-width: ${props => props.theme.phone}px) {
    margin: 0;
    width: 100vw;
  }
`
const Heading = styled.div`
  font-family: ${props => props.theme.secondaryFont};
  font-weight: ${props => props.theme.medium};
  font-size: 20px;
  color: white;
  padding: 25px 10px;
`
